import Checkbox from 'antd/lib/checkbox/Checkbox'
import React, { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import List from '../../components/List'
import FloatingButton from '../../components/UI/FloatingButton'
import SmartSearch from '../../components/UI/SmartSearch'
import SwitchInput from '../../components/UI/SwitchInput'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getDrawerManagementList, saveDrawerManagement } from '../../services/drawerManagement'
import { drawerManager } from './types'


function index() {
  const {canEdit} = useAuth()
  const loading = useLoading()
  const [drawerManagementList, setDrawerManagementList] = useState<drawerManager[]>([])
  const [drawerManagementInitial, setDrawerManagementInitial] = useState<drawerManager[]>([])
  const [search, setSearch] = useState({
    text: '',
    obj: {
      id: '',
      name: '',
      type: ''
    }
  })
  const [validSearch, setValidSearch] = useState(false)
  const log = {
    log_type: 'visited',
    log_object: 'drawer_management'
  }
  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const onRefresh = async () => {
    loading.addLoading()
    let params = {
      [`${search.obj.type}Id`]: search.obj.id,
    }
    const res = await getDrawerManagementList(params)
    setDrawerManagementList(res)
    const responseCopy = await getDrawerManagementList(params)
    setDrawerManagementInitial(responseCopy)
    loading.removeLoading()
  }

  const onChange = (value: boolean, id: number, field: string) => {
     let drawer = drawerManagementList
     const index = drawer.findIndex((o: drawerManager) => o.id === id)
     if( index !== -1 ) {
      drawer[index] = {
        ...drawer[index],
        [field]: value,
      }
      if(field === 'posDrawerEnable' && !value) {
        drawer[index] = {
          ...drawer[index],
          sendExcessCash: value
        }
      }
      setDrawerManagementList([...drawer])
     }
  }

  const onSubmit = async () => {
    loading.addLoading()
    const payload: drawerManager[] = []
    drawerManagementList.map((o) => {
      const drawerFound = drawerManagementInitial.find((drawer) => drawer.id === o.id)
      if(JSON.stringify(o) !== JSON.stringify(drawerFound)) payload.push({
        id: o.id,
        posDrawerEnable: o.posDrawerEnable,
        sendExcessCash: o.sendExcessCash
      })
    })
    await saveDrawerManagement(payload)
    await onRefresh()
    loading.removeLoading()
  }

  return (
    <div className="drawer-management">
      <FloatingButton
        text="Save"
        onClick={onSubmit}
        disabled={(JSON.stringify(drawerManagementInitial) === JSON.stringify(drawerManagementList)|| !canEdit)}
      />
      <ActionArea buttonText={'Search'} buttonAction={onRefresh} disabled={!validSearch}>
        <SmartSearch
          label="Smart Search"
          searchBy={['distributor', 'charity', 'location']}
          status='active'
          value={search.text}
          onChange={(e: string) => setSearch({...search, text: e})}
          onObjValueChange={(e: any) => setSearch({...search, obj: e})}
          onValidSearch={setValidSearch}
          autoFocus
        />
      </ActionArea>
      <List
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            render: (value: string) => value,
          },
          {
            title: 'POS Drawer Enable',
            dataIndex: 'posDrawerEnable',
            key: 'posDrawerEnable',
            width: 150,
            render: (value: boolean, record: drawerManager) => (
              <SwitchInput
                onChange={(e: boolean) => onChange(e, record.id, 'posDrawerEnable')} 
                options={{ check: true, uncheck: false }}
                value={value}
                disabled={!canEdit}
              />
            ),
          },
          {
            title: 'Send Excess Cash Notification to Charity',
            dataIndex: 'sendExcessCash',
            key: 'sendExcessCash',
            width: 150,
            render: (value: boolean, record: drawerManager) => (
              <SwitchInput
                disabled={!record.posDrawerEnable || !canEdit}
                onChange={(e: boolean) => onChange(e, record.id, 'sendExcessCash')} 
                options={{ check: true, uncheck: false }}
                value={value}
              />
            ),
          },
        ]}
        rows={drawerManagementList}
      />
    </div>
  )
}

export default index